import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography, Card, Statistic } from "antd";
import {
  EyeOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  ApiOutlined,
} from "@ant-design/icons";
import columns from "@staticData/admin/adminCardsTableColumns";
import moment from "moment-jalaali";
import DeleteCard from "@general/deleteCard";
import ActiveCard from "@general/activateCard";
import DeactivateCard from "@general/deactivateCard";
function AdminCardsListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
  onDataUpdate,
  cardStats,
}) {
  const [tableData, setTableData] = useState([]);
  const { getCardsCount: count, getCards: cards } = data;

  useEffect(() => {
    const initialTableData = [];
    cards.map((card) => {
      const {
        id,
        createdAt,
        updatedAt,
        cardNo,
        cardIdentifier,
        deliveredAt,
        deactivatedAt,
        issuedAt,
        description,
        cardStatus,
        user,
      } = card;
      initialTableData.push({
        key: id,
        updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
        issuedAt: moment(issuedAt).format("jYYYY/jMM/jDD"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        deliveredAt: moment(deliveredAt).format("jYYYY/jMM/jDD"),
        cardNo,
        deactivatedAt,
        cardIdentifier,
        cardStatus: deactivatedAt ? "DEACTIVATED" : cardStatus,
        description,
        user: user.name,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id, user.name)}>
              <EyeOutlined />
            </a>
            |
            {deactivatedAt ? (
              <ActiveCard
                id={id}
                name={user?.name}
                onActivateCard={onDataUpdate}
              >
                <a>
                  <CheckCircleOutlined />
                </a>
              </ActiveCard>
            ) : (
              <DeactivateCard
                id={id}
                name={user?.name}
                onDeactivateCard={onDataUpdate}
              >
                <a>
                  <ApiOutlined />
                </a>
              </DeactivateCard>
            )}
            |
            <DeleteCard id={id} name={user.name} onDeleteCard={onDataUpdate}>
              <a>
                <DeleteOutlined />
              </a>
            </DeleteCard>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [cards]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      {cardStats && (
        <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
          <Col xs={24} sm={8}>
            <Card
              size="small"
              bordered
              style={{
                borderRadius: 8,
                textAlign: "center",
                backgroundColor: "#f0f5ff",
                borderColor: "#adc6ff",
              }}
            >
              <Statistic
                title="کل کارت‌های صادرشده"
                value={cardStats.totalIssued ?? 0}
                loading={cardStats.loading}
                valueStyle={{ color: "#1d39c4", fontWeight: 700 }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card
              size="small"
              bordered
              style={{
                borderRadius: 8,
                textAlign: "center",
                backgroundColor: "#f6ffed",
                borderColor: "#b7eb8f",
              }}
            >
              <Statistic
                title="کارت‌های فعال"
                value={cardStats.activeIssued ?? 0}
                loading={cardStats.loading}
                valueStyle={{ color: "#389e0d", fontWeight: 700 }}
              />
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card
              size="small"
              bordered
              style={{
                borderRadius: 8,
                textAlign: "center",
                backgroundColor: "#fff1f0",
                borderColor: "#ffa39e",
              }}
            >
              <Statistic
                title="کارت‌های غیرفعال"
                value={cardStats.inactiveIssued ?? 0}
                loading={cardStats.loading}
                valueStyle={{ color: "#cf1322", fontWeight: 700 }}
              />
            </Card>
          </Col>
        </Row>
      )}

      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminCardsListTable;
